import React from "react";

// Classnames
import clsx from "clsx";

// Type
import { TDataTargetDetails } from "pages/Thesaurus/reducer";

const noValue = () => {
  return <p className="target-details__value">No data available</p>;
};

interface ITargetDetails {
  data?: TDataTargetDetails,
  className?: string;
};

export const TargetDetails: React.FC<ITargetDetails> = ({ data, className = "" }) => {
  const cnWrapper = clsx(
    "target-details__block-content flex flex-ai-start full-width",
    className ? className : ""
  );

  return (<>
    <div className={cnWrapper}>
      <p className="target-details__left-block target-details__name">Nomenclature</p>
      <p className="target-details__right-block target-details__value"
        dangerouslySetInnerHTML={{ __html: data?.name || "" }} />
    </div>
    <div className="target-details__divider" />
    <div className="target-details__block-content flex flex-ai-start full-width">
      <p className="target-details__left-block target-details__name">Previous and unofficial names</p>
      <div className="target-details__right-block flex flex-wrap">
        {data?.synonyms?.length
          ? data?.synonyms?.map(
            (item: string, index) => {
              const text = document.createElement("div");

              text.innerHTML = item || "";
              const value = text.innerText;

              const comma = (data?.synonyms?.length || 0) - 1 !== index ? ", " : "";
              return <p
                key={item}
                className="target-details__value"
                dangerouslySetInnerHTML={{ __html: value + comma }}
              />;
            })
          : noValue()}
      </div>
    </div>
    <div className="target-details__divider" />
    <div className="target-details__block-content flex flex-ai-start full-width">
      <p className="target-details__left-block target-details__name">Genes</p>
      <div className="target-details__right-block">
        {data?.genes?.length
          ? data?.genes?.map((item, index: number) => {
            const name = item?.name;
            const text = document.createElement("div");

            text.innerHTML = name || "";
            const value = text.innerText;

            const comma = (data?.genes?.length || 0) - 1 !== index ? ", " : "";
            return (<a
              href={item.url}
              target="_blank"
              rel="noreferrer"
              key={item.name}
              className="target-details__value"
              dangerouslySetInnerHTML={{ __html: value + comma }}
            />);
          })
          : noValue()}
      </div>
    </div>
  </>);
};

export default TargetDetails;
